import Tooltip from '@mui/material/Tooltip';
import merge from 'lodash/merge';
import { useSelector } from 'BMapsRedux';
import { BackgroundColors } from 'BMapsSrc/themes';
import { conditionalObjectItem } from 'BMapsSrc/util/js_utils';

/**
 * @param {import("@mui/material").TooltipProps} param0
 * @returns
 *
 * Applies the styles used by tooltipster to the MUI tooltip. A caller's `slotProps` is deep-merged
 * on top of these base styles (rather than replacing them), so a caller can add or tweak a slot
 * (e.g. a `popper` offset) without dropping the tooltip/arrow styling.
 */
export default function BMapsTooltip({
    children, noMaxWidth, useColorScheme, fontSize='1rem', slotProps, ...props
}) {
    const colorScheme = useSelector((state) => state.prefs['ColorScheme']);

    // These styles are used by tooltipster in infoDisplay.css
    const popupBgColors = {
        black: '#333333',
        white: '#e5e5e5',
        green: '#1e4c30',
        cyan: '#3f7f7a',
        tan: '#d8d6cd',
    };

    let color = popupBgColors['black'];
    let fontColor = BackgroundColors['black'].textCss;
    if (useColorScheme) {
        color = popupBgColors[colorScheme];
        fontColor = BackgroundColors[colorScheme].textCss;
    }

    const baseSlotProps = {
        tooltip: {
            sx: {
                backgroundColor: color,
                color: fontColor,
                fontSize,
                opacity: 1,
                ...conditionalObjectItem(noMaxWidth, 'maxWidth', '50vw'),
            },
        },
        arrow: {
            sx: {
                color,
                opacity: 1,
            },
        },
    };

    return (
        <Tooltip
            enterDelay={500}
            enterNextDelay={500}
            arrow
            // Deep-merge caller slotProps over the base (into a fresh {} so base isn't mutated;
            // caller values win on leaf conflicts).
            slotProps={merge({}, baseSlotProps, slotProps)}
            {...props}
        >
            {children}
        </Tooltip>
    );
}
